import { useContext, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import SideMenu from "../../components/SideMenu";
import BottomTabBar from "../../components/BottomTabBar";
import { useStytchMemberSession } from "@stytch/react/b2b";
import { useIsMobile } from "@/hooks/useMediaQuery";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";
import ChatFullscreenContext from "../../contexts/ChatFullscreenContext";
import UserContext from "../../contexts/UserContext";
import { isRestrictedEmployee, RESTRICTED_EMPLOYEE_ALLOWED_PATHS } from "@/utils/permissions";

const AppLayout = () => {
  const { session } = useStytchMemberSession();
  const isMobile = useIsMobile();
  const [isChatFullscreen, setIsChatFullscreen] = useState(false);
  const { roles, isLoading } = useContext(UserContext);
  const { pathname } = useLocation();

  // Restricted employees may only reach RESTRICTED_EMPLOYEE_ALLOWED_PATHS —
  // redirect any other path to /inbox. Wait until roles have loaded to avoid
  // a premature redirect.
  const isRestrictedOutsideAllowedPath =
    !isLoading &&
    isRestrictedEmployee(roles) &&
    !RESTRICTED_EMPLOYEE_ALLOWED_PATHS.some((p) => pathname.startsWith(p));

  if (session) {
    if (isRestrictedOutsideAllowedPath) {
      return <Navigate to="/inbox" replace />;
    }
    return (
      <ChatFullscreenContext.Provider value={{ setFullscreen: setIsChatFullscreen }}>
        <div className="flex min-h-dvh">
          {!isMobile && <SideMenu />}
          <div className={cn("min-w-0 grow", isMobile && !isChatFullscreen ? "pb-[60px]" : "md:pb-0")}>
            <Outlet />
          </div>
          {isMobile && !isChatFullscreen && <BottomTabBar />}
        </div>
      </ChatFullscreenContext.Provider>
    );
  }
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Spinner size="xl" />
    </div>
  );
};

export default AppLayout;
